
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("fXwy5", function(module, exports) {
module.exports = JSON.parse("{}");

});


//# sourceMappingURL=en-US.56719037.js.map
